import { render } from "./CombustivelVeiculo.vue?vue&type=template&id=195b0c82"
import script from "./CombustivelVeiculo.vue?vue&type=script&lang=js"
export * from "./CombustivelVeiculo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__